import { render, staticRenderFns } from "./IzvjestajiHKIG.vue?vue&type=template&id=5e0938d4&scoped=true&"
import script from "./IzvjestajiHKIG.vue?vue&type=script&lang=js&"
export * from "./IzvjestajiHKIG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0938d4",
  null
  
)

export default component.exports